import { setResources } from "./bootstrapResources";
import serverReference from "shared/json/serverReference-en-GB.json";
import resources from "shared/json/translations-en-GB.json";

setResources(resources, serverReference);